import { FeatureFlag } from '../FeatureFlag';

/**
 * Rolls out refresh-on-rejection and the recoverable expired-session UX.
 */
export const managedSessionLifecycle = new FeatureFlag({
    key: 'managed-session-lifecycle',
    defaultValue: false,
});
